import {
    mercury, codGray, bridalHeath, saffronMango, tuscany, quarterPearlLusta, sandyBeach,
} from '../../../constants/Colors';

export const CLASS_NAMES = {
    OPTIONAL: 'optional',
    PREFERRED: 'preferred',
    MANDATORY: 'mandatory',
    FILTER: 'filter',
    PROBLEMATIC: 'problematic',
    EXCLUDED: 'excluded',
    REVERTED_EXCLUDED: 'revertedExcluded',
    DERIVED: 'derived',
    LOADING: 'loading',
    HOVERED: 'hovered',
    MARKED: 'marked',
};

export const getMergedConfig = (config = {}) => ({
    [CLASS_NAMES.OPTIONAL]: {
        ...(config.advantage || {
            backgroundColor: quarterPearlLusta,
            borderColor: mercury,
            fontColor: codGray,
        }),
    },
    [CLASS_NAMES.PREFERRED]: {
        ...(config.preferred || {
            backgroundColor: bridalHeath,
            borderColor: saffronMango,
            fontColor: codGray,
        }),
    },
    [CLASS_NAMES.MANDATORY]: {
        ...(config.important || {
            backgroundColor: sandyBeach,
            borderColor: sandyBeach,
            fontColor: codGray,
        }),
    },
    [CLASS_NAMES.FILTER]: {
        ...(config.mustHave || {
            backgroundColor: saffronMango,
            borderColor: saffronMango,
            fontColor: codGray,
        }),
    },
    [CLASS_NAMES.PROBLEMATIC]: {
        ...(config.problematic || {
            backgroundColor: saffronMango,
            borderColor: tuscany,
            fontColor: codGray,
            showIcon: true,
        }),
    },
    [CLASS_NAMES.EXCLUDED]: {
        ...(config.excluded || {
            backgroundColor: mercury,
            borderColor: mercury,
            fontColor: codGray,
        }),
    },
    [CLASS_NAMES.REVERTED_EXCLUDED]: {
        ...(config.revertedExcluded || {
            backgroundColor: mercury,
            borderColor: mercury,
            fontColor: codGray,
        }),
    },
    [CLASS_NAMES.DERIVED]: { ...(config.derived || { showIcon: true }) },
    [CLASS_NAMES.LOADING]: { ...(config.loading || {}) },
    [CLASS_NAMES.HOVERED]: { ...(config.hovered || {}) },
    [CLASS_NAMES.MARKED]: { ...(config.marked || {}) },
});

export const getClassName = ({
    priority, isDerived, isExcluded, hasAdditional,
}) => {
    switch (true) {
        case isExcluded:
            return CLASS_NAMES.EXCLUDED;
        case isDerived:
            return `${CLASS_NAMES.DERIVED} ${priority}`;
        case !!priority:
            return priority;
        case hasAdditional:
            return CLASS_NAMES.REVERTED_EXCLUDED;
        default:
            return '';
    }
};
